<template>

    <el-dialog v-model="isopen" title="播放视频" :before-close="closeplay" width="60%" top="5vh">
        <vue3VideoPlay v-bind="playparam.options" ref="videoPlayer"/>
    </el-dialog>
    
</template>

<script>
import { ref } from 'vue';
const videoPlayer = ref(null);
export default {
  props: ['view','url'],
  data() {
      return {
          isopen: this.view,
          playparam: {
              view:false,
              options:{
                  width:'100%',
                  color: "#409eff", //主题色
                  title: '', //视频名称
                  src: this.url, //视频源
                  muted: false, //静音
                  webFullScreen: false,
                  speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
                  autoPlay: false, //自动播放
                  loop: false, //循环播放
                  mirror: false, //镜像画面
                  ligthOff: false,  //关灯模式
                  volume: 0.3, //默认音量大小
                  control: true, //是否显示控制器
              }
          },

      }
  },

  watch: {
      view(val) {
          if(val) {
                this.isopen=true;
                this.playparam.options.src=this.url;
                this.playparam.options.autoPlay=true; //开启自动播放
          }
      }
  },

  mounted() {
      
  },

  methods: {

    
    /** 关闭窗口 **/
    closeplay() {
        this.isopen=false;
        this.$emit('finish');
    },


  }

}
</script>

<style scoped>
.large {cursor: pointer;width:auto !important;width:420px !important;height:236px;position:relative;}
.large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.middle {cursor: pointer;width:auto !important;width:70px !important;height:70px;position:relative;}
.middle .el-image {width:70px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.middle span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.small {cursor: pointer;width:auto !important;width:50px !important;height:50px;position:relative;}
.small .el-image {width:50px;height:50px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.small span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}

.banner {cursor: pointer;width:auto !important;width:150px !important;height:70px;position:relative;}
.banner .el-image {width:150px;height:70px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;position:relative;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
.banner span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;} 

::v-deep(.defaultthumb) {display: inline-flex !important;justify-content: center !important;align-items: center !important;}
::v-deep(.defaultthumb .el-image__inner) {width:70px;height: 70px;}

.TTL-upload-btn {display: inline-block;width:100%;margin-bottom:20px;}
</style>